import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=7ed454ef&scoped=true&"
import script from "./Album.vue?vue&type=script&lang=js&"
export * from "./Album.vue?vue&type=script&lang=js&"
import style0 from "./Album.vue?vue&type=style&index=0&id=7ed454ef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed454ef",
  null
  
)

export default component.exports